export const NOTIFICATION_RECEIVED = "NOTIFICATION_RECEIVED";
export const NOTIFICATION_DISMISS = "NOTIFICATIONS_DISMISS";
export const TRANSIENT_NOTIFICATION_RECEIVED = "TRANSIENT_NOTIFICATION_RECEIVED";
